import React from 'react';
import { IconPropsType } from 'customTypes/icons';

interface IDownloadIconProps extends IconPropsType {}

const DownloadIcon = ({
  stroke = 'var(--rhino)',
  size = '24px',
  strokeWidth = 1.25,
  ...otherProps
}: IDownloadIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...otherProps}
  >
    <path
      d="M1 13v1a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-1m-4-4-4 4m0 0L5 9m4 4V1"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DownloadIcon;
